module.exports = __webpack_public_path__ + "img/vector-right.6ce52f02.svg";